import script from "./ModalWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ModalWindow.vue?vue&type=style&index=0&id=1f8e5045&lang=css"

const __exports__ = script;

export default __exports__